define('extensions/sammy.EmbeddedLocationProxy',[
    'jquery',
    'lib/lodash4',
    'lib/sammy',
    'services/embeddingService',
    'services/loggingService'
], function (
    $,
    _,
    Sammy,
    embeddingService,
    loggingService
) {
    'use strict';

    var NAMESPACE = 'embedded-sammy-proxy';

    var EmbeddedLocationProxy = function(app, selector) {
        this.app = app;
        this.selector = selector || 'a';
    };

    function getEffectiveTarget($link) {
        var target = $link.attr('target');
        if (target == '_parent' && $link[0].namespaceURI.slice(-3) === 'svg') {
            return;
        } else {
            return target;
        }
    }

    _.assign(EmbeddedLocationProxy.prototype, Sammy.DefaultLocationProxy.prototype, {
        bind: function () {
            var proxy = this;
            this.app.$element().on('click.' + NAMESPACE, this.selector, function (event) {
                var $link         = $(this),
                    href          = $link.attr('href'),
                    target,
                    currentHost,
                    hasTarget,

                    isSelf,
                    isBlankHash,
                    isNotRoute,
                    isNotSameHost,
                    isNotEmpty,
                    isExternal;

                try {
                    target        = getEffectiveTarget($link);
                    currentHost   = window.location.host;
                    hasTarget     = !!target;

                    isSelf        = target === "_self";
                    isBlankHash   = href === "#"; // use <a href="#"...></a> when link is not following href attribute
                    isNotRoute    = href.charAt(0) !== '#';
                    isNotSameHost = !currentHost || href.indexOf(currentHost) < 0;
                    isNotEmpty    = href.length > 0;
                    isExternal    = isNotRoute && isNotSameHost;
                } catch (e) {
                    var dom = $link[0];
                    if (dom && !href) {
                        loggingService.warn("Anchor found without href attribute. " +
                                            "Anchors not linking to their href " +
                                            "should have an href value of hash(#). \n" +
                                            "Offending element: " + dom.outerHTML);
                        loggingService.debug(dom);
                    } else {
                        loggingService.error("An unexpected error occurred in sammy.EmbeddedLocationProxy.js: \n" + e.stack);
                    }
                }

                if ((!isBlankHash && isNotEmpty) && (!hasTarget || isSelf)){
                    event.preventDefault();
                    if (isExternal && !isSelf) {
                        window.open(href, '_blank');
                    } else {
                        proxy.setLocation(href);
                    }
                }
            });

            $(window).on('hashchange.' + NAMESPACE, function () {
                proxy.app.trigger('location-changed');
            });
        },

        unbind: function () {
            this.app.$element().off('click.' + NAMESPACE, this.selector);
            $(window).off('hashchange.' + NAMESPACE);
        },

        getLocation: function () {
            return window.location.hash;
        },

        setLocation: function (newLocation) {
            embeddingService.requestNavigation(newLocation);
        }
    });

    return EmbeddedLocationProxy;
});

